import React from 'react';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,

  Button,

} from "reactstrap";

import CSSTransitionGroup from 'react-addons-css-transition-group';


import ModalForm from '../modal/modal'
import AuthService from "services/auth.service";

import Timestamp from "react-timestamp";
import Loader from "react-loader-spinner";

import "./styles.css";
import AgentTform from '../TicketForms/Tktviewform'
import UserTform from '../TicketForms/EndUser-ViewTktform'




//const viewQuery ="SELECT ID,name,class FROM school ";
 class DTable extends React.Component {
   
    constructor(props) {
        super(props);
        const Currentuser = AuthService.getCurrentUser();
        const CurrentUserAcc=Currentuser.username 
        const currentuserfname=Currentuser.userfullname 

        const UserRoles = Currentuser.roles;

        const isAgent = UserRoles.includes('ROLE_AGENT');

      



        this.state = {
            viewdata:[
              {
                  "id": 22534,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-28T08:00:00.000Z",
                  "updatedAt": "2022-02-28T08:18:58.000Z"
              },

              {
                  "id": 22497,
                  "agent": "test.user",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-23T08:00:00.000Z",
                  "updatedAt": "2022-02-23T10:16:12.000Z"
              }
          ],
            loading:false,
            selectedRows: [],
            isOpen: false,
            targetid:'',
            user:CurrentUserAcc,
            userfullname:currentuserfname,
            isAgent:isAgent
        };

      }



 componentDidMount() {



}

componentWillUnmount(){

}






 
 handleButtonClick = (state) => {
    //alert('action Clicked for Row Number'+ state.target.id);
    this.setState({ isOpen: true , targetid: state.target.id});
  };
  handleChange = state => {
    console.log('state', state.selectedRows);

    this.setState({ selectedRows: state.selectedRows });
  };








  handleFilterChange = (e) =>{ 
  

    let Filterpromise = new Promise((myResolve, myReject) =>{ 
    
    // The producing code (this may take some time)
    this.setState({[e.target.name]: e.target.value})
  
  
  
  
        myResolve(e.target.name);
        myReject("Error");
      
  
  
  
  
    });
    
    Filterpromise.then(
      (value)  =>{console.log(value);},
      (error)  =>{}
    );
    
    
    
  
  //handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})
  
  
  }





  openModal = () => this.setState({ isOpen: true });
  closeModal = () => {this.setState({ isOpen: false ,targetid:''});}


  render(){
    let data = this.state.viewdata
    const TicketCards = () => {

    
      return (
<Row >
     {this.state.viewdata.map((tkt) => {
      return (
    
    
            <Col xs={12} md={4}
          
          key={tkt.id} >
 
    <Card  style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray',
}}>
                <CardHeader  className="text-center">
                  <CardTitle tag="strong" style={{color:"green"}}>Ticket# {tkt.id} - {tkt.sub}</CardTitle>
<hr/>
                </CardHeader>



                <CardBody>
<ul style={{color:"rgb(65,70,75)"}}>
<li><strong>Client:</strong> {tkt.client}</li>

<li><strong>Status:</strong> {tkt.state}</li>
<li><strong>Category:</strong> {tkt.category}</li>

<li><strong>Sub-Category:</strong> {tkt.sub}</li>
<li><strong>Created:</strong> <Timestamp relative date={tkt.createdAt} autoUpdate /></li>
<li><strong>Last Update:</strong> <Timestamp relative date={tkt.updatedAt} autoUpdate /></li>



</ul>

                </CardBody>



                <CardFooter className="text-center" >
                <hr/>

                <Button onClick={this.handleButtonClick} id={tkt.id} style={{backgroundColor:'rgb(101, 153, 57)'}  } >View/Edit</Button>
                </CardFooter>
              </Card>

              


          </Col>
       
      );
    })}
    
    
    </Row>
    
      );
    }






    
let ConditionalTktView = this.state.isAgent ? <AgentTform tktid={this.state.targetid}></AgentTform> :<UserTform tktid={this.state.targetid}></UserTform> ;

  return (
<div>
{ this.state.loading ? 
  <Row className="justify-content-center align-items-center" >

<Loader
        type="Puff"
        color="rgb(101, 153, 57)"
        height={150}
        width={150}
        timeout={15000} //3 secs
      /></Row>
:
<div>
<CardHeader>
    {this.state.isAgent ?  <h5 className="title">Tickets Assigned To Agent {this.state.userfullname}</h5> :
    <h5 className="title">{this.props.tktstates} Tickets For User {this.state.userfullname}</h5>

 }
              
              

                </CardHeader>


<CSSTransitionGroup
      transitionName="example"
      transitionAppear={true}
      transitionAppearTimeout={2000}
      transitionEnter={false}
      transitionLeave={false}>


<TicketCards />
        </CSSTransitionGroup>









                      </div>
}
        { this.state.isOpen ? 
          <ModalForm 
            closeModal={this.closeModal} 
            isOpen={this.state.isOpen} 
            title={"Ticket# " + this.state.targetid}
            hoste={ConditionalTktView}
            size="lg"
          /> 
          : 
          null 
        }





        

</div>

  );
}
}
export default DTable;
